import { maskitoTransform } from '@maskito/core';
import { TextField } from '@radix-ui/themes';
import { action, autorun, computed, makeObservable, observable } from 'mobx';
import { phoneMask } from 'shared/masks/phone-mask';
import { v4 as uuidv4 } from 'uuid';

type InputType = TextField.RootProps['type'];
const contactNumberFormat = /^\+\d{1,3}\d{6,14}$/;
export class MessengerModel {
    readonly id: string;
    selectValue: string = '';
    _inputValue: string = '';
    selectPlaceholder: string;
    error: string = '';

    constructor(selectPlaceholder: string) {
        makeObservable(
            this,
            {
                _inputValue: observable,
                selectValue: observable,
                onInputChange: action,
                onSelectChange: action,
                viewValue: computed,
                label: computed,
                placeholder: computed,
                inputType: computed,
                error: observable,
            },
            { autoBind: true }
        );

        autorun(() => console.log(this._inputValue));
        this.id = uuidv4();
        this.selectPlaceholder = selectPlaceholder;
    }

    onInputChange(val: string) {
        if (this.error) {
            this.error = '';
        }

        if (this.inputType === 'tel') {
            const modelValue = val.replace(/[^\d+]/g, '');
            this._inputValue = modelValue;
            if (!contactNumberFormat.test(modelValue)) {
                this._setError('email');
            }
        } else {
            this._inputValue = val;
        }
    }

    onSelectChange(val: string) {
        this.selectValue = val;
    }

    private _setError(errorType: 'email' | 'required'): void {
        switch (errorType) {
            case 'email': {
                this.error = 'Номер повинен бути у міжнародному форматі: +380XXXXXXXXX';
                break;
            }
            case 'required':
        }
    }

    get viewValue(): string {
        if (this.inputType === 'tel') {
            return maskitoTransform(this._inputValue, phoneMask);
        } else {
            return this._inputValue;
        }
    }

    get label(): string {
        switch (this.selectValue) {
            case 'Telegram': {
                return 'Імʼя користувача або номер телефону';
            }
            case 'WhatsApp': {
                return 'Номер телефону';
            }
            case 'Viber': {
                return 'Номер телефону';
            }
            case 'Signal': {
                return 'Номер телефону';
            }
            case 'Skype': {
                return 'Імʼя користувача';
            }
            case 'Discord': {
                return 'Імʼя користувача';
            }
            default:
                return 'Імʼя користувача або номер телефону';
        }
    }

    get placeholder(): string {
        switch (this.selectValue) {
            case 'Telegram': {
                return 'Імʼя користувача або номер телефону';
            }
            case 'WhatsApp': {
                return '+380XXXXXXXXX';
            }
            case 'Viber': {
                return '+380XXXXXXXXX';
            }
            case 'Signal': {
                return '+380XXXXXXXXX';
            }
            case 'Skype': {
                return 'Імʼя користувача';
            }
            case 'Discord': {
                return 'Імʼя користувача';
            }
            default:
                return 'Імʼя користувача або номер телефону';
        }
    }

    get inputType(): InputType {
        switch (this.selectValue) {
            case 'Telegram': {
                return 'text';
            }
            case 'WhatsApp': {
                return 'tel';
            }
            case 'Viber': {
                return 'tel';
            }
            case 'Signal': {
                return 'tel';
            }
            case 'Skype': {
                return 'text';
            }
            case 'Discord': {
                return 'text';
            }
            default:
                return 'text';
        }
    }
}
